<template>
  <div>
    <el-container>
      <el-header>
      <topnav></topnav>
      </el-header>
      <el-main ><router-view v-if="routerAlive"></router-view></el-main>
      <el-footer><footernav></footernav></el-footer>
  </el-container>
    <div class="fixedRightNav">
        <div class="rightNav">
            <!-- <p class="el-icon-user"></p> -->            
             <transition name="el-fade-in-linear">
                <el-popover placement="left-end" width="300" trigger="click">
                <div >
                    <el-row :gutter="20" class="userNameBox">
                      <el-col :span="9">
                            <el-image style="cursor:pointer" class="userNameImg" :src="userInfo.avatar" fit="fill">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                          </el-image>
                      </el-col>
                      <el-col :span="14" class="userNameBoxText">
                        <p class="userName">用户：{{userInfo.userName}}</p>
                        <p class="level">等级：{{userInfo.level||0}}</p>
                      </el-col>
                  </el-row>
                  <el-divider></el-divider>
                  <el-row  class="cartBox_footer">
                      <el-col :span="12" class="userNameBoxBottom"><router-link to="/myInfomation">个人中心</router-link></el-col>
                      <el-col :span="12" class="userNameBoxBottom"><router-link to="/myOrderRight">订单中心</router-link></el-col>
                  </el-row>
                </div>
              <el-button slot="reference">
                  <p class="el-icon-user"></p>
              </el-button>
            </el-popover>
            </transition>
            <div @click="openCartDrawer" class="shoppingCart">
              <i class="el-icon-shopping-cart-2"></i>
              <p>购物车</p>
              <div class="cartNum"><span>{{totalNumber}}</span></div>
            </div>             
            <!-- <div class="el-icon-view" @click="openFooterDrawer"></div> -->
            
            <transition name="el-fade-in-linear">
                <el-popover popper-class="nolikePopBox"  placement="left-end" width="50" trigger="hover">
                  <div class="userPartPop">
                    我看过的
                  </div>
                  <el-button slot="reference">
                      <div class="el-icon-view" @click="openFooterDrawer"></div>
                  </el-button>
              </el-popover>
            </transition>

            <transition name="el-fade-in-linear">
                <el-popover popper-class="nolikePopBox"  placement="left-end" width="50" trigger="hover">
                  <div class="userPartPop">
                    我收藏的
                  </div>
                  <el-button slot="reference">
                      <div class="nolike" @click="$router.push('/goodsCollection')">
                        <img :src="require('@/assets/img/noLIke.png')" alt="">
                      </div>
                  </el-button>
              </el-popover>
            </transition>    

              <transition name="el-fade-in-linear">
                <el-popover popper-class="userPartPopBox"  placement="left-end" width="100" trigger="hover">
                  <div class="userPartPop">
                      <el-image class="userPartPop_img" style="cursor:pointer" :src="userInfo.avatar" fit="fill">
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                        </el-image>
                        <div class="userPartPop_text">
                          {{this.userInfo.userName}}
                        </div>
                  </div>
                  <el-button slot="reference" class="userPart">
                      <div >
                        <el-image style="cursor:pointer" :src="userInfo.avatar" fit="fill">
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                        </el-image>
                </div>
                  </el-button>
              </el-popover>
            </transition>  
            <transition name="el-fade-in-linear">
                <el-popover popper-class="backTopBox"  placement="left-end" width="100" trigger="hover">
                  <div class="userPartPop">
                     回到顶部
                  </div>
                  <el-button slot="reference" class="">
                      <div >
                        <el-backtop :right=0 :bottom=0>
                          <i class="el-icon-upload2"></i>
                        </el-backtop> 
                      </div>
                  </el-button>
              </el-popover>
            </transition>           
            <!-- <div class="userPart">
               <el-image style="cursor:pointer" :src="require('@/assets/img/user.png')" fit="fill">
                     <div slot="error" class="image-slot">
                       <i class="el-icon-picture-outline"></i>
                     </div>
               </el-image>
            </div> -->
        </div>

        <!-- 购物车 开始 -->
        <el-drawer
        class="drawerCart"
          title="购物车"
          :modal="false"
          :visible.sync="drawer">
              <p class="drawerCartTitle" slot="title"><i class="el-icon-shopping-cart-2"></i> <router-link class="gotoShopText" to="/shoppingcart">购物车</router-link></p>
              <div class="drawerCartItem" v-loading="loading">
                  <div>
                      <div class="cartTip">
                        <el-row :gutter="20" class="cartBox" v-for="(item,index) in list" :key="index">
                            <el-col :span="5">
                              <el-image class="cartgoodsPhotos" @click="$router.push(`/goodsdetail?id=${item.id}`)" :src="`${item.photos}`" fit="fill">
                                
                              </el-image>
                            </el-col>
                            <el-col :span="12"><div @click="$router.push(`/goodsdetail?id=${item.id}`)" class="cartHeight" title="">{{item.name}}</div></el-col>
                            <el-col :span="6"><div class="cartHeight">{{item.realprice}} * {{item.number}}</div></el-col>
                        </el-row>
                      <el-row  class="cartBox_footer">
                          <el-col :span="12"><div class="cartHeight_total"><p class="totalNum">共 {{totalNumber||0}} 件商品</p><p>总计： {{accountTotal.toFixed(2) || 0}} 元</p></div></el-col>
                          <el-col :span="12"><div class="cartHeight_cart"><router-link to="/shoppingcart" style="color:white">去购物车结算</router-link></div></el-col>
                      </el-row>
                    </div>
                  </div>

                  <!-- 购物车没有东西的时候 -->
                  <div class="drawerCartItem_no" v-if="list.length==0?true:false">
                      <el-image style="cursor:pointer" :src="require('@/assets/img/noresult.png')" fit="fill">
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                      </el-image>
                      <p>您的购物车里什么都没有哦</p> 
                      <router-link class="gotoShopText" to="/goodsList">再去看看吧</router-link>
                  </div>
              </div>
        </el-drawer>
        <!-- 购物车 结束 -->

        <!-- 我的足迹 开始-->
        <el-drawer
        class="drawerCart"
          title="购物车"
          :modal="false"
          :visible.sync="footerdrawer">
              <p class="drawerCartTitle" slot="title"><i class="el-icon-view"></i> <router-link class="gotoShopText" to="/myFooter">我的足迹</router-link></p>
              <div class="drawerCartItem drawerFooterItem" v-loading="footloading">
                  <div class="isdrawerFooterItem" v-for="(item,index) in footerlist" :key="index">
                      <div  class="isdrawerFooterItemBg" v-if="item.commodity!=null">
                          <el-image class="goodsFooter" style="cursor:pointer" @click="$router.push(`/goodsdetail?id=${item.commodity.id}`)" :src="`${item.commodity.photos}`" fit="fill">
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                          </el-image>
                        <div class="cartHeight">￥{{item.commodity.realprice}}</div>
                      </div>
                  </div>

                  <!-- 购物车没有东西的时候 -->
                  <div class="drawerCartItem_no" v-if="footerlist.length==0?true:false">
                      <el-image style="cursor:pointer" :src="require('@/assets/img/noresult.png')" fit="fill">
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                      </el-image>
                      <p>暂无您的浏览记录</p> 
                      <router-link class="gotoShopText" to="/goodsList">再去看看吧</router-link>
                  </div>
              </div>
        </el-drawer>
        <!-- 我的足迹 结束-->
    </div>
  </div>
</template>
<script>
// 导入组件
import topnav from "../components_supplier/topnav.vue";
import footernav from "../components/footernav.vue";
import {shoppingCartlist,footprint_list } from "@/api/xunyou";
import {mapState,mapMutations} from 'vuex'
export default {
  name: "index",
  data() {
    return {
      routerAlive:true,
      footloading:false,
      footerdrawer:false,
      footerlist:[],
      showclass: "asideshow",
      showtype: false,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      drawer: false,
      loading:false,
      // accountTotal:0,
      // list:[],
    };
  },
  provide(){    //在父组件中创建属性
      return {
          routerRefresh: this.routerRefresh
      }
  },
   computed:{
    ...mapState(['list','accountTotal','totalNumber'])
  },
  // 注册组件
  components: {
    footernav,
    topnav,
  },
  created() {
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  mounted() {
    // if(this.userInfo.loginName!=null||this.userInfo.loginName!="" ){
    //       this.getshoppingCartlist();
    // }
    this.getfootList()
    	// 	$('.li_dorpdown').hover(function() {
		// 	$('.dorpdown-layer').show();
		// });
		// $('.li_dorpdown').mouseleave(function() {
		// 	$('.dorpdown-layer').hide();
		// });
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: "登录成功",
    //   type: "success",
    // });
  },
  methods:{
     routerRefresh(){
	        this.routerAlive = false;
        this.$nextTick(()=>{
            this.routerAlive = true;
        });
	    },

    // // 购物车查询
    // getshoppingCartlist() {
    //   this.accountTotal =0
    //    this.loading = true
    //   shoppingCartlist({uid:this.userInfo.userId||''})
    //     .then((res) => {
    //      if(res.length>0){
    //         this.loading = false
    //      let newList= []
    //       res.forEach((x)=>{            
    //           x.bxunyouMerchant.goods.forEach((y)=>{
    //             newList.push(y)
    //           })
    //       })
    //         this.list = newList;
    //         let sum = this.list.reduce((sum, item) => {
    //                   return sum + item.realprice * item.number; // 隐式转换             
    //               }, 0);
    //               this.accountTotal += sum;
    //      }
    //         })
    //     .catch((err) => {
    //       // this.$message.error("查询购物车失败，请稍后再试！");
    //     });
    // },

    // 打开侧边的购物车
    openCartDrawer(){
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
        this.drawer = true
         this.footerdrawer = false
        // this.getshoppingCartlist()
    },

      // 查询我的足迹
  getfootList() {
    this.loading = true;
      footprint_list({uid:this.userInfo.userId})
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.footerlist = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("我的足迹查询失败，请稍后再试！");
        });
    },

     // 打开侧边的我的足迹
    openFooterDrawer(){
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
        this.footerdrawer = true
        this.drawer = false
        // this.footerlist = this.list
        this.getfootList()
    },
    // handleClose(done) {
    //     this.$confirm('确认关闭？')
    //       .then(_ => {
    //         done();
    //       })
    //       .catch(_ => {});
    //   }
  }
};
</script>
<style lang="less" scoped>
.el-header {
    padding: 0 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -ms-flex-negative: 0;
    flex-shrink: 0;
}
/* 
布局后续删除start
 */
.el-header,
.el-footer {
  /* background-color: #b3c0d1; */
  color: #333;
  text-align: center;
  /* line-height: 60px; */
  height: auto !important;
  padding: 0 0px;
}
.el-main {
    /* background-color: #E9EEF3; */
    color: #333;
    /* text-align: center; */
    /* line-height: 160px; */
    padding: 0px;
  } 
/* 
布局后续删除end
 */

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}


.userNameBox{
      .el-image.userNameImg {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 1px solid #dadada;
      }
      .userNameBoxText.el-col.el-col-14 {
          position: relative;
          transform: translate(0, 50%);
          line-height: 30px;
          font-size: 16px;
      }
    }
.userNameBoxBottom.el-col.el-col-12 {
    text-align: center;
    margin-bottom: 10px;
    a{
      display: inline-block;
      padding: 5px 20px;
      background: #f7f7f7;
      border: 1px solid #cecece;
      border-radius: 4px;
    }
}
.fixedRightNav{
  .rightNav {
    width: 40px;
    height: 100%;
    position: fixed;
    background: #444851;
    z-index: 2;
    top: 0;
    right: 0;
    color: white;
    padding-top: 15%;
    box-sizing: border-box;
    text-align: center;
    z-index: 9999;
    .el-button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: transparent;
        border: 0px solid transparent;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        padding: 0;
        font-size: 14px;
        border-radius: 0px;
        width: 100%;
    }    
    p.el-icon-user {
      font-size: 26px;
      display: block;
      height: 40px;
      line-height: 40px;
      color: #d9dada;
    }
    p.el-icon-user:hover {
      background: #78b942;
      cursor: pointer;
    }
    .shoppingCart:hover {
        background: #78b942;
        cursor: pointer;       
    }
    .shoppingCart{
      margin: 20px 0;
      padding: 20px 0;
      i.el-icon-shopping-cart-2 {
        font-size: 26px;
        color: #d9dada;
    }
    
      p,.cartNum{
          font-size: 16px;
          padding: 0 10px;
          color: #d9dada;
          span{
            display: inline-block;
            width: 24px;
            background:#78b942;
            border-radius: 10px;
          }
      }    
    }
      .el-icon-view{
          font-size: 25px;
          display: block;
          height: 40px;
          line-height: 40px;
          color: #d9dada;
      }
      .el-icon-view:hover {
          background: #78b942;
          cursor: pointer;
          
      }
      .nolike{
        width: 100%;
        height: auto;
        margin: 6px 0;
        padding: 8px 0;
        img{
          width: 70%;
        }
      } 
      .nolike:hover {
          background: #78b942;
          cursor: pointer;
          
      } 
      .userPart {
          bottom:50px;
          position: absolute;
          padding: 4px;
          left: 0px;
          .el-image {
              border-radius: 50%;
          }
      }

      // 回到顶部
      .el-backtop{
        background: transparent;
        color: white;
        i.el-icon-upload2 {
            font-size: 25px;
        }
      }
      .el-backtop:hover {
          background: #78b942;
          border-radius: 0;
      }      
  }
  .drawerCart{
    /deep/ :focus {
      outline: 0;
    }
    /deep/.el-drawer.rtl {
        padding-right: 50px;
        padding-left: 20px;
        background: #eceaea;
        /deep/.el-drawer__header{
          padding: 15px 0px;
          margin-bottom: 0;
        }
    }
    .drawerCartTitle{
      font-size: 17px;
      color: #5e5050;
      i.el-icon-shopping-cart-2 {
          font-size: 22px;
          vertical-align: middle;
      }
    }
    .drawerCartItem{
      height: 900px;
      overflow: auto;
      padding-bottom: 50px;
      .drawerCartItem_no {
          text-align: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 16px;
          .gotoShopText{
              color: #78b942;
          }
      }

    }
    .drawerFooterItem{
       display: flex;
          // justify-content: space-between;
          flex-wrap: wrap;
      .isdrawerFooterItem {
         
          .isdrawerFooterItemBg{
            background: white;
            padding: 8px;
            box-sizing: border-box;
            border-radius: 6px;
            margin-bottom: 15px;
            margin-right: 15px;
            .goodsFooter{
              width: 120px;
              height: 120px;
              background: #f5f5f5;
              cursor: pointer;
              position: relative;
              /deep/.image-slot {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            }
            .cartHeight {
                text-align: center;
                font-size: 16px;
            }

          }
      }
    }

    

    /* 购物车的样式 */
      .cartTip{
        .cartBox.el-row {
            margin: 15px;
            background: white;
            width: 100%;
            padding: 10px;
          .el-image.cartgoodsPhotos {
                height: 80px;
                width: 100%;
                position: inherit;
                cursor: pointer;
            }
            .cartHeight {
                height: 80px;
                line-height: 80px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }
            
        }
        .cartHeight_total {
            font-size: 18px;
            padding: 0 20px;
            color: #78b942;
            .totalNum{
                font-size: 14px;
                color: #000;
            }
        }
        .cartHeight_cart {
            height: 40px;
            text-align: center;
            line-height: 40px;
            background: #78b942;
            color: white;
            font-size: 15px;
            a.router-link-exact-active.router-link-active {
                color: white;
            }
          }

      }
  }
  
}
 .userPartPop{
        display: flex;
        justify-content: space-evenly;
    /deep/.el-image.userPartPop_img {
        width: 40px;
        border-radius: 50%;
    }
    /deep/.userPartPop_text {
        line-height: 40px;
    }
  }
  /deep/.el-popover.el-popper.nolikePopBox {
    background: #5b5f67;
    color: white;
}
  

</style>



// WEBPACK FOOTER //
// src/views_supplier/index.vue